var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 4.73391C15.6702 4.40391 12.3202 4.23391 8.98024 4.23391C7.00024 4.23391 5.02024 4.33391 3.04024 4.53391L1.00024 4.73391M6.50024 3.72391L6.72024 2.41391C6.88024 1.46391 7.00024 0.753906 8.69024 0.753906H11.3102C13.0002 0.753906 13.1302 1.50391 13.2802 2.42391L13.5002 3.72391M16.8502 7.89391L16.2002 17.9639C16.0902 19.5339 16.0002 20.7539 13.2102 20.7539H6.79024C4.00024 20.7539 3.91024 19.5339 3.80024 17.9639L3.15024 7.89391M8.33024 15.2539H11.6602M7.50024 11.2539H12.5002",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteConfirmation);
export default __webpack_public_path__ + "static/media/deleteConfirmation.420e84396fee07a5bc876cd1af65f4db.svg";
export { ForwardRef as ReactComponent };